<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :countries="countries"
            :effectiveness="effectiveness"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @TaxExemptionFormSubmit="create"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/TaxExemption/Form'

export default {
    name: 'TaxExemptionCreate',
    components: { Form },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        effectiveness: {
            type: Array,
            default: () => []
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        create (form) {
            form.post(this.$route('settings.tax-exemption.store'))
        }
    }
}
</script>
